<template>
	<div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Nome *</label>
		        <input 
		        	type="text" 
		        	class="form-control" 
		        	v-model="dados.name" 
		        	:id="name+'name'" 
		        	@input="clearValidation('name')">
		        <div class="invalid-feedback" :id="name+'name-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-12">
		        <label>E-mail *</label>
		        <input 
		        	type="text" 
		        	class="form-control" 
		        	v-model="dados.email" 
		        	:id="name+'email'" 
		        	@input="clearValidation('email')">
		        <div class="invalid-feedback" :id="name+'email-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-12">
		    	<label>Perfil *</label>
		    	<select-two 
		        	:options="roles" 
		        	:formId="name+'role_id'"
		        	:valueDefault="dados.role"
		        	@selected="setRoleId"
		        	@searching="getRoles"
		        	arrayValue="name">
		        </select-two>
		    </div>
		    <div class="form-group col-md-12">
		        <label v-if="method == 'create'">Senha *</label>
		        <label v-else>Senha</label>
		        <input 
		        	type="password" 
		        	class="form-control" 
		        	v-model="dados.password" 
		        	:id="name+'password'" 
		        	@input="clearValidation('password')">
		        <div class="invalid-feedback" :id="name+'password-invalid-feedback'"></div>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados', 'name', 'errors', 'method'],
		data(){
			return {
				elementos: Object.keys(this.dados),
				roles: []
			}
		},
		created(){
			this.getRoles();
		},
		methods : {
			getRoles(pesquisa=''){
				axios.get(this.$url+'/api/adm/roles/list?pesquisa='+pesquisa)
	            .then(response => {
	                this.roles = response.data.data
	            })
			},
			setRoleId(valor){
				this.dados.role = valor.name;
			},
			clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			}
        },
        watch: {
            errors: function() {
                this.$bshValidation.valide(this.elementos, this.errors, this.name);
            },
        }
    }
</script>
